document.addEventListener('DOMContentLoaded', () => {
  const mainImage = document.querySelector('.js-main-product-image');
  const thumbs = document.querySelectorAll('.js-product-thumb');

  if (!mainImage || !thumbs.length) return;

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const imageUrl = thumb.dataset.image;
      const alt = thumb.dataset.alt || '';

      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = imageUrl;
      mainImage.alt = alt;

      thumbs.forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });
});